import CreateClaim, {CreateClaimProps} from "../../components/CreateClaim/create_claim";

const CreateClaimView = (props: CreateClaimProps) => {
  return (
    <CreateClaim {...props}/>
  );
};

export default CreateClaimView;